import { useStaticQuery, graphql } from "gatsby"

export  const useStrapiToolkitPageData = () => {
    const { strapiTrainingToolKit } = useStaticQuery(graphql`
        query {
            strapiTrainingToolKit {
                title
                slug
                description
                keywords
                hero_image {
                    headline
                    description {
                      data {
                        childMarkdownRemark {
                          html
                        }
                      }
                    }
                    background_image {
                      alternativeText
                      localFile {
                        childImageSharp {
                          gatsbyImageData(aspectRatio: 1.77)
                        }
                      }
                    }
                  }
                resources {
                  name
                    localFile {
                      prettySize
                    }
                }
                glossary {
                  name
                    localFile {
                      prettySize
                    }
                }
                full_toolkit {
                  name
                    localFile {
                      prettySize
                    }
                }
                overview {
                  data {
                    childMarkdownRemark {
                      html
                    }
                  }
                }
                text {
                  data {
                    childMarkdownRemark {
                      html
                    }
                  }
                }
              }
        }
    `)
    return { strapiTrainingToolKit }
}